import {
  BarChart,
  formatPercentage,
  CurrencyValue,
  Flex,
  ChartSkeleton,
  EmptyBox
} from '@blockanalitica/ui';

import { getCollateralEmptyBoxText } from '@/components';
import type { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { useMemo } from 'react';
import { useApi } from '@/api';
import { ChartConfig } from '@blockanalitica/ui/package/types/src/components/charts/Chart';

type AtRiskData = {
  results: SimpleChartData[];
};
export default function AtRiskPerDropChart({
  marketAddress,
  tag,
  symbol,
  ...rest
}: {
  marketAddress: string;
  tag: string;
  symbol: string;
}) {
  const valueFormatter = (value: string | number) => {
    return (
      <CurrencyValue
        value={value}
        variant="dynamic"
        options={{ currency: 'USD' }}
      />
    );
  };

  const xScaleValueFormatter = (value: string | number) => {
    return formatPercentage(Number(value));
  };

  const subValueFormatter = (value: string | number) => {
    return `At ${formatPercentage(Number(value))} market price decrease`;
  };

  const [data, error] = useApi<AtRiskData>({
    url: `/markets/${marketAddress}/at-risk/`
  });
  const datasets = [
    {
      xField: 'price_change',
      yField: 'liquidated_usd',
      backgroundColor: '#ffa480'
    }
  ];

  if (error) {
    throw error;
  }
  const config: ChartConfig = useMemo(() => {
    return {
      options: {
        scales: {
          x: {
            type: 'linear'
          }
        }
      }
    };
  }, []);

  if (!data) {
    return (
      <Flex flexDirection="column" gap="xs" {...rest}>
        <ChartSkeleton />
      </Flex>
    );
  }
  return (
    <BarChart
      data={data.results}
      config={config}
      datasets={datasets}
      valueFormatter={valueFormatter}
      xScaleValueFormatter={xScaleValueFormatter}
      subValueFormatter={subValueFormatter}
      emptyComponent={
        <EmptyBox message={getCollateralEmptyBoxText(tag, symbol)} />
      }
    />
  );
}
